import script from "./search-history.vue?vue&type=script&setup=true&lang=ts"
export * from "./search-history.vue?vue&type=script&setup=true&lang=ts"

import "./search-history.vue?vue&type=style&index=0&id=1d265e94&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d265e94"]])

export default __exports__